import React from "react";
import { ButtonTypes } from "../../utils/Constants";

const Button: React.FC<{
  type: ButtonTypes;
  onClick: () => void;
  className?: string;
  children?: React.ReactNode;
  disabled?: boolean;
  // The native <button type>. Left unset (the default), a Button inside a
  // <form> acts as a submit button — pass "button" for anything that
  // shouldn't submit, e.g. Cancel.
  htmlType?: "button" | "submit";
}> = (props) => {
  const { type, onClick, className, children, disabled, htmlType } = props;

  let classes = "";
  switch (type) {
    case ButtonTypes.PRIMARY:
      classes = "bg-primary text-white hover:bg-[#526554] hover:disabled:bg-primary disabled:opacity-70 px-8 py-4 disabled:cursor-not-allowed";
      break;
    case ButtonTypes.SECONDARY:
      classes = "bg-secondary px-4 py-2";
      break;
    case ButtonTypes.CANCEL:
      classes = "bg-white text-black41 hover:font-bold cursor-pointer px-8 py-4";
      break;
    case ButtonTypes.DEFAULT:
      break;
  }

  return (
    <button
      type={htmlType}
      className={`first-letter:capitalize rounded-full duration-500 ${classes} ${className}`}
      onClick={() => {
        if (!disabled) onClick?.();
      }}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
